import { useMedia } from 'react-media-match';
import { useIntl } from 'react-intl';

export type UseUrlParameters = (
  url: string,
  parameters?: { [key: string]: string },
  isLegacyLocale?: boolean,
) => string | null;

/**
 * This hook replaces <device> and <locale> in a given string with the values provided by the page context
 * Additionaly an object with key/value pairs can be passed and to be replaced in the string.
 * Pattern: `<${key}>` -> value
 */
export const useUrlParameters: UseUrlParameters = (url, parameters, isLegacyLocale = false) => {
  const device = useMedia({ desktop: 'web', mobile: 'mob', tablet: 'tab' });
  let { locale } = useIntl();
  const language = locale.substring(0, 2);

  if (!url) {
    return null;
  }

  if (isLegacyLocale) {
    locale = locale.replace('-', '_');
  }

  let editedUrl = url
    .replace('<device>', device)
    .replace('<locale>', locale)
    .replace('<language>', language);
  if (parameters) {
    Object.keys(parameters).map((key) => {
      editedUrl = editedUrl.replace(`<${key}>`, parameters[key]);
      return true;
    });
  }
  return editedUrl;
};

export default useUrlParameters;
